import { render } from "./ForbiddenPage.vue?vue&type=template&id=024fb756&scoped=true"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js"

import "./ForbiddenPage.vue?vue&type=style&index=0&id=024fb756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024fb756"]])

export default __exports__